import React, { Component } from 'react';

import './serviceFee.scss';

// Banner merah Marketing Balance — non-closable, tanpa icon (per Figma).
// Nempel di bawah banner MSF kalau dua-duanya aktif (stacking via body class).
class GlobalMarketingBalanceBanner extends Component{
  render(){
    const { show, amount, onTopup, t } = this.props;

    if(!show){
      return null;
    }

    return(
      <div className="service-fee-banner marketing-balance-banner" role="alert">
        <span className="service-fee-banner-body">
          <span className="service-fee-banner-text">{t('marketingBalance.banner', { amount })}</span>
          {' '}
          <button type="button" className="service-fee-banner-link" onClick={onTopup}>
            {t('topUp')}
          </button>
        </span>
      </div>
    );
  }
}

export default GlobalMarketingBalanceBanner;
